import React from "react";
import { Calculation } from "../../../../../../src/application/Contracts";
import BaseTechTable from "./BaseTechTable";

export default class AquaFirstTable extends BaseTechTable<Calculation.AquaFirstAndGeniusTechnicalData[]> {
    getItems = () => {
        return Object.values(this.props.items).filter(i => i.direct === this.state.activeDirect && i.temperatureProgram == this.getFilterTemperatureProgram()).sort(
            (a, b) => {
                if (a.dimensions > b.dimensions) {
                    return 1;
                } else if (a.dimensions < b.dimensions) {
                    return -1;
                } else {
                    if (Number.parseInt(a.nominalCapacity) < Number.parseInt(b.nominalCapacity)) {
                        return -1;
                    } else if (Number.parseInt(a.nominalCapacity) > Number.parseInt(b.nominalCapacity)) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            }
        );
    }
    getCurrency = (): string => {
        return this.getItems()[0]?.currency || "";
    }

    getTable() {
        let lastDimensions: string | null = null;
        return <table>
            <thead>
                <tr>
                    <th rowSpan={2}>{__("Model")}</th>
                    <th rowSpan={2}>{__("Nominal capacity")}</th>
                    <th rowSpan={2}>{__("Primary flowrate (m3/h)")}</th>
                    <th rowSpan={2}>{__("Dimensions")}</th>
                    <th colSpan={this.state.activeDirect ? 2 : 3}>{__("Weight (kg)")}</th>
                    {this.state.activeDirect && <th colSpan={2}>{__("Single primary pump")}</th>}
                    {this.state.activeDirect && <th colSpan={2}>{__("Double primary pump")}</th>}
                    {!this.state.activeDirect && <th colSpan={2}>{__("Single primary pump, single charging pump")}</th>}
                    {!this.state.activeDirect && <th colSpan={2}>{__("Double primary pump, single charging pump")}</th>}
                    {!this.state.activeDirect && <th colSpan={2}>{__("Double primary pump, double charging pump")}</th>}
                </tr>
                <tr>
                    {this.state.activeDirect && <th>{__("IS")}</th>}
                    {this.state.activeDirect && <th>{__("ID")}</th>}
                    {!this.state.activeDirect && <th>{__("SS")}</th>}
                    {!this.state.activeDirect && <th>{__("DS")}</th>}
                    {!this.state.activeDirect && <th>{__("DD")}</th>}
                    <th>{__("Article no.")}</th>
                    <th>{__("Public price" + " " + this.getCurrency())}</th>
                    <th>{__("Article no.")}</th>
                    <th>{__("Public price" + " " + this.getCurrency())}</th>
                    {!this.state.activeDirect && <th>{__("Article no.")}</th>}
                    {!this.state.activeDirect && <th>{__("Public price" + " " + this.getCurrency())}</th>}
                </tr>
            </thead>
            <tbody>
                {this.getItems().map(item => {
                    let rowClassName = '';
                    if (lastDimensions !== null && lastDimensions !== item.dimensions) {
                        rowClassName = 'border-top';
                    }
                    lastDimensions = item.dimensions;
                    return <tr className={rowClassName} key={item.nominalCapacity}>
                        <td>{item.model}</td>
                        <td>{item.nominalCapacity}</td>
                        <td>{item.flowRate}</td>
                        <td>{item.dimensions}</td>
                        {this.state.activeDirect && <React.Fragment>
                            <td>{item.singlePrimaryPump.weight}</td>
                            <td>{item.doublePrimaryPump.weight}</td>
                            <td>{item.singlePrimaryPump.articleNumber}</td>
                            <td>{item.singlePrimaryPump.price}</td>
                            <td>{item.doublePrimaryPump.articleNumber}</td>
                            <td>{item.doublePrimaryPump.price}</td>
                        </React.Fragment>}
                        {!this.state.activeDirect && <React.Fragment>
                            <td>{item.singlePrimaryPumpSingleChargingPump.weight}</td>
                            <td>{item.doublePrimaryPumpSingleChargingPump.weight}</td>
                            <td>{item.doublePrimaryPumpDoubleChargingPump.weight}</td>
                            <td>{item.singlePrimaryPumpSingleChargingPump.articleNumber}</td>
                            <td>{item.singlePrimaryPumpSingleChargingPump.price}</td>
                            <td>{item.doublePrimaryPumpSingleChargingPump.articleNumber}</td>
                            <td>{item.doublePrimaryPumpSingleChargingPump.price}</td>
                            <td>{item.doublePrimaryPumpDoubleChargingPump.articleNumber}</td>
                            <td>{item.doublePrimaryPumpDoubleChargingPump.price}</td>
                        </React.Fragment>}
                    </tr>
                })}
            </tbody>
        </table>
    }
}